import type { Theme } from '@mui/material';
// import type { Components } from '@mui/material/styles';

export default function MUIBreadcrumbs(theme: Theme) /* : Components['MuiBreadcrumbs'] */ {
  return {
    defaultProps: {
      separator: '›',
    },
    styleOverrides: {
      separator: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
      },
      li: {
        '&:hover a': {
          color: theme.palette.primary.main,
        },
      },
    },
    // variants: [],
  };
}
